import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeSeriesScale,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeSeriesScale
);

export const Data2 = [
  {
    send_time: '1689030069050.6687',
    htr_device: 'htr-002',
    metrics: {
      BATTERY: ['1689030068.9603245', 'BATTERY', 12.0, 'volts', 0, 20],
      SPEED: ['1689030068.999951', 'SPEED', 0.0, 'kph', 0, 0],
      WATER_TEMP: ['1689030068.999951', 'WATER_TEMP', 41.7, 'Celcius', 0, 0],
      LATITUDE: [
        '1689030068.932241',
        'LATITUDE',
        -121.93443359999999,
        'degrees',
        0,
        0,
      ],
      LONGITUDE: [
        '1689030068.9333355',
        'LONGITUDE',
        37.4959217,
        'degrees',
        0,
        0,
      ],
      TPS: ['1689030069.0503936', 'TPS', 0.0, 'position', 0, 65],
      BRAKE: ['1689030068.9422448', 'BRAKE', 265.6, 'bar', 325, 647],
    },
  },
  {
    send_time: '1689030069560.814',
    htr_device: 'htr-002',
    metrics: {
      BATTERY: ['1689030069.479286', 'BATTERY', 12.0, 'volts', 0, 20],
      SPEED: ['1689030069.5245037', 'SPEED', 0.0, 'kph', 0, 0],
      WATER_TEMP: [
        '1689030069.5245037',
        'WATER_TEMP',
        41.800000000000004,
        'Celcius',
        0,
        0,
      ],
      LATITUDE: [
        '1689030069.4311144',
        'LATITUDE',
        -121.9344301,
        'degrees',
        0,
        0,
      ],
      LONGITUDE: [
        '1689030069.4321861',
        'LONGITUDE',
        37.495918499999995,
        'degrees',
        0,
        0,
      ],
      TPS: ['1689030069.5605128', 'TPS', 0.0, 'position', 0, 65],
      BRAKE: ['1689030069.4605534', 'BRAKE', 203.4, 'bar', 325, 647],
    },
  },
];

export const options = {
  responsive: true,
  aspectRatio: 4,
  tension: 0,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: false,
      text: 'Chart.js Line Chart',
    },
  },
  scales: {
    y: {
      //   suggestedMin: 0,
      //   suggestedMax: 100,
      min: -5,
      max: 105,
    },
    x: {
      display: false,
      // type: TimeSeriesScale,
    },
  },
  elements: {
    point: {
      radius: 0,
    },
  },
};

export function MinMaxPercentage(metric) {
  const [time, metName, val, unit, min, max] = metric;
  const percent = ((val - min) / (max - min)) * 100;
  const theValue = percent;
  return theValue;
}

export function ChartTest({ my_data }) {
  if (my_data) {
    const data = {
      labels: my_data.map((d) => d.send_time),
      datasets: [
        {
          label: 'BRAKE',
          data: my_data.map((d) => MinMaxPercentage(d.metrics.BRAKE)),
          // data: my_data.map((d) => d.metrics.BRAKE[2]),
          borderColor: 'rgb(255, 99, 132)',
          backgroundColor: 'rgba(255, 99, 132, 0.5)',
        },
        {
          label: 'THROTTLE',
          data: my_data.map((d) => MinMaxPercentage(d.metrics.TPS)),
          borderColor: 'rgb(53, 162, 235)',
          backgroundColor: 'rgba(53, 162, 235, 0.5)',
        },
        {
          label: 'SPEED',
          data: my_data.map((d) => MinMaxPercentage(d.metrics.SPEED)),
          borderColor: 'rgb(77, 77, 76)',
          backgroundColor: 'rgba(77, 77, 76, 0.5)',
        },
      ],
    };
    return <Line options={options} data={data} />;
  }
}
